var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error"},[_c('p',[_vm._v("拒绝访问")]),_c('div',{on:{"click":_vm.goIndex}},[_vm._v("返回首页")])])
}
var staticRenderFns = []

export { render, staticRenderFns }